import { type DomainAccessControlConfig } from '../utils/domain/accessControl'
import { Permission } from './permissions'
import { FeatureToggle } from './featureToggles'

export const incentiveBudgetsViewAccessControl: DomainAccessControlConfig = {
  // TODO(incentive-budgets): restore the permission gate before merging. The
  // `incentive_budgets.view` permission is not yet registered in backend RBAC, so
  // gating on it locks everyone out. Until RBAC is wired, gate on the feature
  // toggle alone for local/staging testing.
  // permissions: [Permission.IncentiveBudgetsView],
  featureToggles: [FeatureToggle.IncentiveBudgets],
}

export const incentiveBudgetsModifyAccessControl: DomainAccessControlConfig = {
  permissions: [Permission.IncentiveBudgetsModify],
  featureToggles: [FeatureToggle.IncentiveBudgets],
}
